module.exports = __webpack_public_path__ + "img/plexus-6.762b9cc3.png";